import type {ApiService} from "~/services/ApiService";
import type {OioTemplate} from "~~/api/models";

export class OioTemplateService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  async  getOioTemplate(tenant: string, origin: number): Promise<OioTemplate> {
    return await this.apiService.get<OioTemplate>(`/api/oiotemplate/${origin}`, {
      headers: {
        'X-TENANT-ID': tenant,
      }
    });
  }
}